import * as React from 'react';
import styled from './index.module.scss';
import Gallery from '@/components/ReferralHalloween/Share/ProductGallery/Gallery';
import Descriptions from '@/components/ReferralHalloween/Share/ProductGallery/Descriptions';
import getLocal from '@/app/utils/getLocal';

export type DescriptionProps = {
    title: string;
    content: string;
};

const descItems: { [key: string]: DescriptionProps[] } = {
    us: [
        {
            title: 'Energize Almost Everything',
            content: '4000W, 120V/240V to power \nalmost all of your essential \nhome appliances with just a single unit.',
        },
        {
            title: 'Plug and Play',
            content: 'One tap start and maintenance-free operation.',
        },
        {
            title: 'Silent as a Whisper',
            content: 'X-Quiet \nfor ultra-quiet operation (as low as 30 dB*).',
        },
        {
            title: 'Forget Refuelling',
            content: 'Forget fuel worries with 7 unique and 18 combo fast charging methods',
        },
    ],
    ca: [
        {
            title: 'Energize Almost Everything',
            content: '4000W, 120V/240V to power \nalmost all of your essential \nhome appliances with just a single unit.',
        },
        {
            title: 'Plug and Play',
            content: 'One tap start and maintenance-free operation.',
        },
        {
            title: 'Silent as a Whisper',
            content: 'X-Quiet \nfor ultra-quiet operation (as low as 30 dB*).',
        },
        {
            title: 'Forget Refuelling',
            content: 'Forget fuel worries with 7 unique and 18 combo fast charging methods',
        },
    ],
};

export default function ProductGallery() {
    const { locale } = getLocal();
    const items = descItems[locale] || descItems['us'];

    return (
        <div className={styled.product_gallery}>
            <Descriptions items={items} />
            <Gallery />
        </div>
    );
}
